

class RppColors {

    public static deviceOnline()   {
        return "#009900";
    }

    public static deviceOffline()   {
        return "#990000";
    }

    public static deviceActiveResourceNone()   {
        return "#990000";
    }

    public static deviceActiveResourceMain()   {
        return "#009900";
    }

    public static deviceActiveResourceFallbackUrl()   {
        return "#BBBB00";
    }

    public static deviceActiveResourceFailoverTrack()   {
        return "#EF8C00";
    }

    public static deviceActiveResourceEvent()   {
        return "#B441D6";
    }

    public static deviceActiveResourceLocalUsb()   {
        return "#107BC3";
    }

    public static deviceActiveResourcePriority()   {
        return "#9E420D";
    }

    public static deviceActiveResourceUndefined()   {
        return "#888888";
    }

    public static deviceDisabled()   {
        return "#888888";
    }

    public static isOn()   {
        return "#009900";
    }

    public static isOff()   {
        return "#660A0A";
    }

    public static error()   {
        return "#E00000";
    }

}


export default RppColors;
